import React from 'react';
import { Box, Grid, Typography, CircularProgress, Chip, Button } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { useEffect, useState } from 'react';
import logo from "../assets/studentlogo.png"
import books from "../assets/books.png"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { LinearProgress } from "@mui/material";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SchoolIcon from '@mui/icons-material/School';
import { MenuItem, Select, FormControl, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { makeApiRequest } from '../utils/api';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventIcon from '@mui/icons-material/Event';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { convertToIST } from '../helpers/timeHelper';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import signin from "../assets/sign-in.png"
import boyandirl from "../assets/boyandgirl.png"
import plus from "../assets/plus.png"
import done from "../assets/done.png"
import { formatDate } from "../helpers/timeHelper";
import { getLocationList, getLocation } from '../helpers/commonHelper';
import { set } from 'date-fns';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export const Dashboard = () => {

    // **Styles**
    const boxStyle = {
        height: "140px",
        backgroundColor: "white",
        borderRadius: "5px",
        display: "flex",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        justifyContent: "center",
        alignItems: "center",
    };

    const clickableBoxStyle = {
        ...boxStyle,
        cursor: "pointer",
    };

    const imageContainerStyle = {
        width: "80%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    };

    const imageStyle = {
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
    };

    const centerFlex = {
        display: "flex",
        justifyContent: "center",
    };

    const columnFlex = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    };

    const subTextStyle = {
        fontSize: "12px",
        color: "#6B7280",
        fontFamily: "Roboto",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
    };

    const courseTextStyle = {
        fontSize: "14px",
        color: "#6B7280",
        fontFamily: "Roboto",
    };

    const courseDetailStyle = {
        fontSize: "14px",
        color: "#111827",
        fontWeight: "400",
        fontFamily: "Roboto",
    };

    const chipStyle = {
        backgroundColor: "#9C27B01A",
        padding: "0px 8px",
        border: "1px solid #9C27B0",
        color: "#9C27B0",
        width: "fit-content",
        fontWeight: 500,
    };

    const checkIconStyle = {
        color: "#29BF12",
        marginRight: "4px",
        fontSize: "20px",
    };

    const warningIconStyle = {
        fontSize: "60px",
        marginBottom: "8px",
        color: "#FF0000",
    };



    const todayDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const [month, day, year] = todayDate.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    var today_date = formattedDate;
    const parseDateString = (dateString) => {
        if (!dateString) return null;
        const parts = dateString.split('-');
        if (parts.length < 2) return null;
        return {
            day: parseInt(parts[0], 10),
            month: parseInt(parts[1], 10)
        };
    };
    const [presentStaff, setPresentStaff] = useState(0);
    const [presentStud, setPresentStud] = useState(0);
    const [value, setValue] = useState(0);
    const [radioValue, setRadioValue] = useState('all');
    const [filteredData, setFilteredData] = useState([]);
    const [today, setToday] = useState(0);
    const [upcoming, setUpcoming] = useState(0);
    const [attendanceTab, setAttendanceTab] = useState(0);
    const [selectedStaffTab, setSelectedStaffTab] = useState(1);
    const [selectedStudTab, setSelectedStudTab] = useState(1);
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(false);
    const userLocation = getLocation(localStorage.getItem('userLocation'))
    // const [attendanceData, setAttendanceData] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [learningData, setLearningData] = useState(0);
    const [error, setError] = useState(null);
    const [studentBasic, setStudentBasic] = useState([]);
    const [pendingRequestsCount, setPendingRequestsCount] = useState(0);

    const control = localStorage.getItem('control');
    // const userLocation = getLocation(localStorage.getItem('userLocation'));
    const userName = (control != 1 && control != 4) ? localStorage.getItem('username') : null;

    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    });

    const navigate = useNavigate();

    // Chart data
    const [donutStaffData, setDonutStaffData] = useState({
        labels: ['Present', 'Absent'],
        datasets: [{
            label: 'Count',
            data: [0, 0],
            backgroundColor: ['green', '#D20506'],
            borderWidth: 1,
        }],
    });

    const [donutStudData, setDonutStudData] = useState({
        labels: ['Present', 'Absent'],
        datasets: [{
            label: 'Count',
            data: [0, 0],
            backgroundColor: ['green', '#D20506'],
            borderWidth: 1,
        }],
    });

    // Fetch All Data Together
    useEffect(() => {
        const fetchAllDashboardData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const today = formatDateyear(new Date().toISOString());

                const [dashboardRes, studentRes, attendanceRes, basicRes] = await Promise.all([
                    makeApiRequest('post', "/api/generate-report", { date: today, token }),
                    makeApiRequest('post', '/api/learning/student', {
                        token,
                        start_date: startDate,
                        end_date: endDate,
                        location: ((control == 2 || control == 3 || control == 4) && userLocation) ? userLocation : '',
                        name: (control == 3 && userName) ? userName : '',
                        page: 1,
                        per_page: 10,
                    }),
                    makeApiRequest('post', '/api/attendance/punch-in', { token, action: 'get' }),
                    control == 3 ? makeApiRequest('post', "/api/employee/student", { token, userid: localStorage.getItem('userid') }) : Promise.resolve(null),
                ]);

                setDashboardData(dashboardRes.data);
                setLearningData(studentRes.data.data.length > 0 ? 1 : 0);
                setAttendanceData(attendanceRes.data);
                if (basicRes) {
                    setStudentBasic(basicRes.data);
                }

                if (control == 1) {
                    const reqRes = await makeApiRequest('post', '/api/edit-requests/pending', { token, per_page: 1 });
                    if (reqRes && reqRes.status === 'success') {
                        setPendingRequestsCount(reqRes.data?.total ?? (Array.isArray(reqRes.data) ? reqRes.data.length : 0));
                    }
                }
            } catch (error) {
                console.error(error);
                setError('Failed to load dashboard');
            } finally {
                setLoading(false);
            }
        };

        fetchAllDashboardData();
    }, []);

    // Filter Events
    useEffect(() => {
        if (dashboardData?.events) {
            filterEvents(value, radioValue);
        }
    }, [dashboardData, value, radioValue]);

    // Attendance Charts
    useEffect(() => {
        if (dashboardData?.attendance) {
            const staffData = attendanceTab === 0
                ? dashboardData.attendance.staff?.today || {}
                : dashboardData.attendance.staff?.yesterday || {};

            const studData = attendanceTab === 0
                ? dashboardData.attendance.stud?.today || {}
                : dashboardData.attendance.stud?.yesterday || {};

            setPresentStaff(staffData?.present || 0);
            setPresentStud(studData?.present || 0);

            const totalStaff = dashboardData?.staff_task_journey?.day1?.total_active_staff || 0;
            const totalStud = dashboardData?.active_students_count || 0;

            const absentStaff = totalStaff - (staffData?.present || 0);
            const absentStud = totalStud - (studData?.present || 0);

            setDonutStaffData({
                labels: ['Present', 'Absent'],
                datasets: [{
                    label: 'Count',
                    data: [(staffData?.present || 0), absentStaff],
                    backgroundColor: ['green', '#D20506'],
                    borderWidth: 1,
                }],
            });

            setDonutStudData({
                labels: ['Present', 'Absent'],
                datasets: [{
                    label: 'Count',
                    data: [(studData?.present || 0), absentStud],
                    backgroundColor: ['green', '#D20506'],
                    borderWidth: 1,
                }],
            });
        }
    }, [dashboardData, attendanceTab]);

    // Helper Functions
    const filterEvents = (tabValue, eventType) => {
        if (!dashboardData?.events) return;

        const todayFormatted = formatDateForComparison(new Date());
        const allEvents = [...dashboardData.events];

        const todayEvents = allEvents.filter(event => isSameDateAndMonth(event.dob || event.doj, todayFormatted));
        const upcomingEvents = allEvents.filter(event => !isSameDateAndMonth(event.dob || event.doj, todayFormatted));

        setToday(todayEvents.length);
        setUpcoming(upcomingEvents.length);

        let filtered = tabValue === 0 ? todayEvents : upcomingEvents;

        if (eventType !== 'all') {
            const eventTypeMapping = {
                birthday: 'Birthday',
                anniversary: 'Anniversary',
                newJoinee: 'New joinee',
            };
            filtered = filtered.filter(event => event.type === eventTypeMapping[eventType]);
        }

        setFilteredData(filtered);
    };

    const formatDateyear = (dateString) => {
        const date = new Date(dateString);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };

    const formatDateForComparison = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${day}-${month}`;
    };

    const formatMonthDate = (dateString, isDob = false) => {
        if (!dateString) return '-'; // Return '-' if no date is available
        const dateParts = dateString.split('-'); // Assuming the format is DD-MM-YYYY
        const date = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);

        if (isDob) {
            // Format for dob: e.g., "20 Nov"
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
            });
        } else {
            // Format for doj or other dates: e.g., "20 Nov 2025"
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            });
        }
    };

    const isSameDateAndMonth = (dateString1, dateString2) => {
        const date1 = parseDateString(dateString1);
        const date2 = parseDateString(dateString2);
        if (!date1 || !date2) return false;
        return date1.day === date2.day && date1.month === date2.month;
    };

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
        filterEvents(newValue, radioValue);
    };

    const handleDropdownChange = (newValue) => {
        setRadioValue(newValue);
        filterEvents(value, newValue);
    };

    const handleAttendanceTabChange = (event, newValue) => {
        setAttendanceTab(newValue);
    };

    const handleStaffTabChange = (event, newValue) => {
        setSelectedStaffTab(newValue);
    };

    const handleStudTabChange = (event, newValue) => {
        setSelectedStudTab(newValue);
    };

    const handleClick = () => {
        navigate('/punch-in');
    };

    const click = () => {
        navigate('/add-learning-journey');
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
        cutout: '70%',
    };
    const formatDateWithoutYear = (dateString) => {
        if (!dateString) return '-'; // Return dash if empty
        const dateParts = dateString.split('-'); // Assuming DD-MM-YYYY format
        return `${dateParts[0]}-${dateParts[1]}`; // Return DD-MM (day-month)
    };


    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'error.main' }}>
                <Typography variant="h6">{error}</Typography>
            </Box>
        );
    }

    return (
        <>
            <Box sx={{
                margin: 0, backgroundColor: "#ECEDFF", minHeight: "100vh", display: "flex",
                flexDirection: "column"
            }}>
                <Grid container sx={{ display: "flex", justifyContent: "center", flexGrow: 1 }}>
                    <Grid item xs={11} sx={{
                        display: "flex",
                        flexDirection: "column",
                    }}>
                        <Grid container sx={{ justifyContent: "space-between" }}>

                            {(control == 1 || control == 4 || control == 2) && (
                                <>
                                    <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Grid item lg={6.5} md={12} sm={12} xs={12} sx={{ borderRadius: "5px" }}>
                                        <Grid container sx={{ display: "flex", justifyContent: { lg: "space-between", md: "space-between", sm: "space-between", xs: "center" }, marginTop: "20px" }}>
                                            <Grid item lg={5.5} md={5.8} sm={5.8} xs={12} sx={{ height: "auto", margin: "" }}>
                                                {/* <Box sx={{ height: "150px%", backgroundColor: "#ECEDFF", width: "100%", display: "flex", justifyContent: "space-between", alignItems: "" }}> */}
                                                <Box sx={{ height: "100px", width: "100%", backgroundColor: 'white', borderRadius: "5px", display: "flex", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                                                    <Box sx={{ height: "100%", width: "50%", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
                                                        <Typography variant="h4" sx={{ fontWeight: 750 }}>{dashboardData?.active_students_count}</Typography>
                                                        <Typography sx={{ fontSize: "14px", color: "#6B7280", fontFamily: "Roboto" }} >ACTIVE STUDENTS</Typography>
                                                    </Box>
                                                    <Box sx={{ height: "100%", width: "50%", display: "flex", alignItems: "center" }}>
                                                        <img style={{ height: "85%", width: "100%", objectFit: 'contain' }} src={logo} alt="none" />
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item lg={5.5} md={5.8} sm={5.8} xs={12} sx={{
                                                height: "auto", backgroundColor: "white", borderRadius: "5PX", marginTop: {
                                                    lg: "0px", md: "0px", sm: "0", xs: "10px"
                                                }
                                            }}>
                                                <Box sx={{ height: "100px", width: "100%", backgroundColor: '', borderRadius: "5px", display: "flex", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                                                    <Box sx={{ height: "100%", width: "50%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                                        <Typography variant="h4" sx={{ fontWeight: 750 }}>{dashboardData?.total_courses}</Typography>
                                                        <Typography sx={{ fontSize: "14px", color: "#6B7280", fontFamily: "Roboto" }} >COURSES</Typography>
                                                    </Box>
                                                    <Box sx={{ height: "100%", width: "50%", display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                                        <img style={{ height: "85%", width: "100%", objectFit: 'contain' }} src={books} alt="books" />
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <Grid container sx={{ display: "flex", justifyContent: { lg: "space-between", md: "space-between", sm: "space-between", xs: "center" }, marginTop: "20px", marginBottom: "20px" }}>
                                            <Grid item lg={5.5} md={5.8} sm={5.8} xs={12} sx={{ height: "auto", backgroundColor: "white", borderRadius: '5PX' }}>
                                                <Box sx={{ height: "160px", width: "100%", borderRadius: "5px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>

                                                    <Box sx={{ height: "35%", width: "100%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
                                                        <Tabs value={selectedStaffTab} onChange={handleStaffTabChange} aria-label="task journey tabs">
                                                            <Tab label="Day B4 yest" />
                                                            <Tab label="yest" />
                                                        </Tabs>
                                                    </Box>

                                                    <Box sx={{ height: "40%", width: "100%", backgroundColor: "", textAlign: "center" }}>
                                                        <Box sx={{ height: "60%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: '' }}>
                                                            <Typography variant="h4" sx={{ fontWeight: 600, color: "blue" }}>
                                                                {selectedStaffTab === 0 ? dashboardData?.staff_task_journey?.day1?.task_comp_staff : dashboardData?.staff_task_journey?.day0?.task_comp_staff}
                                                                <span style={{ color: "#481E82" }}>/{selectedStaffTab === 0 ? dashboardData?.staff_task_journey?.day1?.total_active_staff : dashboardData?.staff_task_journey?.day0?.total_active_staff}</span>
                                                            </Typography>
                                                        </Box>

                                                        <Box sx={{ height: "40%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "" }}>
                                                            <LinearProgress
                                                                variant="determinate"
                                                                value={selectedStaffTab === 0
                                                                    ? (dashboardData?.staff_task_journey?.day1?.task_comp_staff / dashboardData?.staff_task_journey?.day1?.total_active_staff * 100) || 0
                                                                    : (dashboardData?.staff_task_journey?.day0?.task_comp_staff / dashboardData?.staff_task_journey?.day0?.total_active_staff * 100) || 0
                                                                }
                                                                sx={{ marginTop: "3px", height: 4, width: "65%", fontSize: "10px" }}
                                                            />
                                                            <Typography variant="body2" sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "8px" }}>
                                                                {selectedStaffTab === 0
                                                                    ? ((dashboardData?.staff_task_journey?.day1?.task_comp_staff / dashboardData?.staff_task_journey?.day1?.total_active_staff * 100) || 0).toFixed(2)
                                                                    : ((dashboardData?.staff_task_journey?.day0?.task_comp_staff / dashboardData?.staff_task_journey?.day0?.total_active_staff * 100) || 0).toFixed(2)
                                                                }%
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ height: "20%", width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', gap: 1 }}>
                                                        <PeopleAltIcon color="primary" />
                                                        <Typography sx={{ fontWeight: 400, fontFamily: "Roboto", fontSize: "18px", }}>Staffs Task Journey</Typography>
                                                    </Box>

                                                </Box>
                                            </Grid>
                                            <Grid item lg={5.5} md={5.8} sm={5.8} xs={12} sx={{ height: "160px", marginTop: { lg: "0px", md: "0px", sm: "0", xs: "10px" } }}>
                                                <Box sx={{ height: "160px", width: "100%", backgroundColor: 'white', borderRadius: "5px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                                                    <Box sx={{ height: "35%", width: "100%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
                                                        <Tabs value={selectedStudTab} onChange={handleStudTabChange} aria-label="task journey tabs">
                                                            <Tab label="Day B4 Yest" />
                                                            <Tab label="yest" />
                                                        </Tabs>
                                                    </Box>

                                                    <Box sx={{ height: "40%", width: "100%", backgroundColor: "", textAlign: "center" }}>
                                                        <Box sx={{ height: "60%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: '' }}>
                                                            <Typography variant="h4" sx={{ fontWeight: 600, color: "blue" }}>
                                                                {selectedStudTab === 0 ? dashboardData?.stud_task_journey?.day1?.task_comp_stud : dashboardData?.stud_task_journey?.day0?.task_comp_stud}
                                                                <span style={{ color: "#481E82" }}>/{selectedStudTab === 0 ? dashboardData?.stud_task_journey?.day1?.total_active_stud : dashboardData?.stud_task_journey?.day0?.total_active_stud}</span>
                                                            </Typography>
                                                        </Box>

                                                        <Box sx={{ height: "40%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "" }}>
                                                            <LinearProgress
                                                                variant="determinate"
                                                                value={selectedStudTab === 0
                                                                    ? (dashboardData?.stud_task_journey?.day1?.task_comp_stud / dashboardData?.stud_task_journey?.day1?.total_active_stud * 100) || 0
                                                                    : (dashboardData?.stud_task_journey?.day0?.task_comp_stud / dashboardData?.stud_task_journey?.day0?.total_active_stud * 100) || 0
                                                                }
                                                                sx={{ marginTop: "3px", height: 4, width: "65%" }}
                                                            />
                                                            <Typography variant="body2" sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "8px" }}>
                                                                {selectedStudTab === 0
                                                                    ? ((dashboardData?.stud_task_journey?.day1?.task_comp_stud / dashboardData?.stud_task_journey?.day1?.total_active_stud * 100) || 0).toFixed(2)
                                                                    : ((dashboardData?.stud_task_journey?.day0?.task_comp_stud / dashboardData?.stud_task_journey?.day0?.total_active_stud * 100) || 0).toFixed(2)
                                                                }%
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ height: "20%", width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', gap: 1 }}>
                                                        {/* Add School Icon */}
                                                        <SchoolIcon color="primary" />
                                                        <Typography sx={{ fontWeight: 400, fontFamily: "Roboto", fontSize: "18px", }}>Students Learning Journey</Typography>
                                                    </Box>

                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={5} md={12} sm={12} xs={12} sx={{
                                        backgroundColor: "white",
                                        borderRadius: "5px",
                                        marginTop: "20px",
                                        height: "280px", // Fixed height
                                        // height: "auto",
                                        overflow: "hidden",
                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
                                    }}>
                                        {/* Header Section */}
                                        <Box sx={{ height: "100px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="h5" sx={{ fontWeight: 700, fontFamily: "Roboto" }}>
                                                Attendance
                                            </Typography>
                                            <Tabs
                                                value={attendanceTab}
                                                onChange={handleAttendanceTabChange}
                                                centered
                                                sx={{
                                                    minHeight: 32,
                                                    '& .MuiTab-root': {
                                                        minHeight: 32,
                                                        textTransform: 'none'
                                                    }
                                                }}
                                            >
                                                <Tab label="Today" sx={{ fontSize: "17px" }} />
                                                <Tab label="Yesterday" sx={{ fontSize: "17px" }} />
                                            </Tabs>
                                        </Box>

                                        {/* Charts Section */}
                                        <Grid container sx={{ height: "170px", display: "flex", flexWrap: "nowrap" }}>
                                            {/* Students Chart */}

                                            {/* Staff Chart */}
                                            <Grid item xs={12} sm={6} sx={{ height: "100%" }}>
                                                <Box sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    justifyContent: "space-between",
                                                    // py: 1
                                                }}>
                                                    <Box sx={{ position: "relative", width: 130, height: 130 }}>
                                                        <Doughnut data={donutStaffData} options={options} />
                                                        <Box sx={{
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            textAlign: "center"
                                                        }}>
                                                            <Typography sx={{ fontSize: "22px", color: "blue", fontWeight: 600 }}>
                                                                {presentStaff}
                                                                <span style={{ color: "#481E82" }}>/{dashboardData?.staff_task_journey?.day1?.total_active_staff}</span>
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Box sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1
                                                    }}>
                                                        <PeopleAltIcon sx={{ fontSize: 24, color: "primary.main" }} />
                                                        <Typography variant="h6" sx={{
                                                            color: "primary",
                                                            fontWeight: 400,
                                                            fontFamily: "Roboto",
                                                            fontSize: "18px",
                                                        }}>
                                                            Staffs
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} sx={{ height: "100%" }}>
                                                <Box sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    justifyContent: "space-between",
                                                    // py: 1
                                                }}>
                                                    <Box sx={{ position: "relative", width: 130, height: 130 }}>
                                                        <Doughnut data={donutStudData} options={options} />
                                                        <Box sx={{
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            textAlign: "center"
                                                        }}>
                                                            <Typography sx={{ fontSize: "22px", color: "blue", fontWeight: 600 }}>
                                                                {presentStud}
                                                                <span style={{ color: "#481E82" }}>/{dashboardData?.active_students_count}</span>
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Box sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1
                                                    }}>
                                                        <SchoolIcon sx={{ fontSize: 24, color: "primary.main" }} />
                                                        <Typography variant="h6" sx={{
                                                            color: "primary",
                                                            fontWeight: 400,
                                                            fontFamily: "Roboto",
                                                            fontSize: "18px",
                                                        }}>
                                                            Students
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {(control == 1) && (
                                    <Grid container sx={{ marginTop: "20px" }}>
                                        <Grid item xs={12}>
                                            <Box 
                                                onClick={() => navigate('/admin/requests')}
                                                sx={{ 
                                                    height: "80px", 
                                                    width: "100%", 
                                                    backgroundColor: 'white', 
                                                    borderRadius: "5px", 
                                                    display: "flex", 
                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    transition: 'transform 0.2s',
                                                    '&:hover': { transform: 'scale(1.01)' }
                                                }}
                                            >
                                                <Box sx={{ height: "100%", width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
                                                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                             <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                                                 Edit Requests
                                                             </Typography>
                                                             {pendingRequestsCount > 0 && (
                                                                 <Box sx={{ 
                                                                     ml: 1.5, 
                                                                     backgroundColor: 'red', 
                                                                     color: 'white', 
                                                                     borderRadius: '50%', 
                                                                     width: 22, 
                                                                     height: 22, 
                                                                     display: 'flex', 
                                                                     justifyContent: 'center', 
                                                                     alignItems: 'center', 
                                                                     fontSize: '12px',
                                                                     fontWeight: 'bold'
                                                                 }}>
                                                                     {pendingRequestsCount}
                                                                 </Box>
                                                             )}
                                                         </Box>
                                                         <Typography sx={{ fontSize: "12px", color: "#6B7280", fontFamily: "Roboto" }} >
                                                             Manage pending student mark changes
                                                         </Typography>
                                                     </Box>
                                                     <Box sx={{ display: 'flex', gap: 1 }}>
                                                         <Button 
                                                             variant="outlined" 
                                                             color="secondary" 
                                                             size="small"
                                                             onClick={(e) => {
                                                                 e.stopPropagation();
                                                                 navigate('/admin/edit-history');
                                                             }}
                                                         >
                                                             History
                                                         </Button>
                                                     </Box>
                                                 </Box>
                                             </Box>
                                         </Grid>
                                     </Grid>
                                 )}
                                </>
                            )}
                            {control == 3 && (
                                <Grid container spacing={2} sx={{ marginTop: "20px" }}>
                                    <Grid item xs={12} sm={6} lg={3} sx={{
                                        height: "auto", borderRadius: "5px", marginTop: { xs: "10px", sm: 0 }
                                    }}>
                                        <Box sx={{ height: "140px", width: "100%", backgroundColor: 'white', borderRadius: "5px", display: "flex", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                                            <Grid container sx={{ alignItems: "center" }}>
                                                <Grid item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                                                    <Box sx={{ textAlign: "center" }}>
                                                        <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 1 }}>{dashboardData?.total_courses}</Typography>
                                                        <Typography sx={{
                                                            fontSize: "12px",
                                                            color: "#6B7280",
                                                            fontFamily: "Roboto",
                                                            fontWeight: 600,
                                                        }} >COURSES</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6} sx={{ display: "flex", justifyContent: "center", }}>
                                                    <Box sx={{ height: "100%", width: { xs: "80%", md: "60%", lg: "80%" } }}>
                                                        <img style={{ height: "100%", width: "100%", objectFit: 'contain' }} src={books} alt="books" />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={3} sx={{
                                        height: "auto", borderRadius: "5px", marginTop: { xs: "10px", sm: 0 }
                                    }}>
                                        <Box sx={{ height: "140px", width: "100%", backgroundColor: 'white', borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "90%", width: "90%" }}>
                                                <Typography sx={{ fontSize: "14px", color: "#6B7280", fontFamily: "Roboto" }} >{studentBasic.batch_name}</Typography>
                                                <Typography sx={{ fontSize: "14px", color: "#111827", fontWeight: "400", fontFamily: "Roboto" }} >{studentBasic.course}</Typography>
                                                <Chip
                                                    icon={
                                                        <QueryBuilderIcon
                                                            sx={{
                                                                color: "#9C27B0 !important"
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography variant="body2">
                                                            Due on : <span style={{ color: "#B3261E", fontWeight: 700 }}>{formatDate(studentBasic.batch_endDate)}</span>
                                                        </Typography>
                                                    } size="small"
                                                    sx={{
                                                        backgroundColor: "#9C27B01A",
                                                        padding: "0px 8px",
                                                        border: "1px solid #9C27B0",
                                                        color: "#9C27B0",
                                                        width: "fit-content",
                                                        fontWeight: 500,
                                                        ".MuiChip-icon": {
                                                            color: "#9C27B0 !important"
                                                        }
                                                    }}
                                                />

                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={3} sx={{
                                        height: "auto", borderRadius: "5px", marginTop: { xs: "10px", sm: 0 }
                                    }}>
                                        <Box
                                            onClick={handleClick}
                                            sx={{
                                                cursor: "pointer",
                                                height: "140px",
                                                width: "100%",
                                                backgroundColor: 'white',
                                                borderRadius: "5px",
                                                display: "flex",
                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
                                            }}
                                        >
                                            <Grid container sx={{ alignItems: "center" }}>
                                                <Grid item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                                                    {attendanceData.punch_in_time !== null && (
                                                        <Box sx={{
                                                            height: "100%",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "flex-start"
                                                        }}>
                                                            <Typography variant="h5" sx={{ fontWeight: 700, color: "#481e82" }}>
                                                                {convertToIST(attendanceData.punch_in_time)}
                                                            </Typography>
                                                            <Typography sx={{
                                                                fontSize: "12px",
                                                                color: "#6B7280",
                                                                fontFamily: "Roboto",
                                                                fontWeight: 600,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                mt: "2px"
                                                            }}>
                                                                <CheckCircleIcon sx={{ color: "#29BF12", mr: .5, fontSize: "20px" }} />SIGNED IN
                                                            </Typography>
                                                        </Box>

                                                    )}
                                                    {attendanceData.punch_in_time === null && (
                                                        <Box sx={{
                                                            height: "100%",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column"
                                                        }}>
                                                            <WarningAmberIcon sx={{ fontSize: "60px", mb: 1, color: "#FF0000" }} />
                                                            <Typography sx={{
                                                                fontSize: "12px",
                                                                color: "#6B7280",
                                                                fontFamily: "Roboto",
                                                                fontWeight: 600,
                                                                display: "flex",
                                                                alignItems: "center"
                                                            }}>
                                                                HAVEN'T SIGNED IN
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Grid>
                                                <Grid item xs={6} sx={{ display: "flex", justifyContent: "center", }}>
                                                    <Box sx={{
                                                        height: "100%",
                                                        width: { xs: "80%", md: "60%", lg: "80%" },
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    }}>
                                                        <img
                                                            style={{ height: "100%", width: "100%", objectFit: 'contain' }}
                                                            src={signin}
                                                            alt="signin"
                                                        />
                                                    </Box>
                                                </Grid>

                                            </Grid>

                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={3} sx={{
                                        height: "auto", borderRadius: "5px", marginTop: { xs: "10px", sm: 0 }
                                    }}>
                                        <Box
                                            onClick={click}
                                            sx={{
                                                cursor: "pointer",
                                                height: "140px",
                                                width: "100%",
                                                backgroundColor: 'white',
                                                borderRadius: "5px",
                                                display: "flex",
                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
                                            }}
                                        >
                                            <Grid container sx={{}}>
                                                <Grid item xs={7} sx={{ height: "100%", display: "flex", justifyContent: "center" }}>

                                                    {learningData == 1 && (
                                                        <Box sx={{
                                                            height: "auto",

                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column",
                                                        }}>
                                                            <Box sx={{
                                                                // width: "45%",
                                                                width: { xs: "45%", md: "35%", lg: "45%" },
                                                                display: 'flex',
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}>
                                                                <img
                                                                    style={{ objectFit: 'contain', height: "100%", width: "100%" }}
                                                                    src={done}
                                                                    alt="done"
                                                                />
                                                            </Box>

                                                            <Typography sx={{
                                                                fontSize: "12px",
                                                                color: "#6B7280",
                                                                fontFamily: "Roboto",
                                                                fontWeight: 600,
                                                                display: "flex",
                                                            }}>
                                                                LEARNING JOURNEY
                                                            </Typography>
                                                        </Box>

                                                    )}
                                                    {learningData == 0 && (
                                                        <Box sx={{
                                                            height: "auto",

                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column",
                                                        }}>
                                                            <Box sx={{
                                                                // width: "45%",
                                                                width: { xs: "45%", md: "35%", lg: "45%" },

                                                                display: 'flex',
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}>
                                                                <img
                                                                    style={{ objectFit: 'contain', height: "80%", width: "80%" }}
                                                                    src={plus}
                                                                    alt="done"
                                                                />
                                                            </Box>

                                                            <Typography sx={{
                                                                fontSize: "12px",
                                                                color: "#6B7280",
                                                                fontFamily: "Roboto",
                                                                fontWeight: 600,
                                                                display: "flex",

                                                            }}>
                                                                ADD LEARNING JOURNEY
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Grid>
                                                <Grid item xs={5} sx={{
                                                    display: "flex", justifyContent: "center",
                                                }}>

                                                    <Box sx={{
                                                        height: "100%",
                                                        // width: "60%",
                                                        width: { xs: "60%", md: "45%", lg: "60%" },
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        alignItems: "center",

                                                    }}>
                                                        <img
                                                            style={{ height: "100%", width: "100%", objectFit: 'contain' }}
                                                            src={boyandirl}
                                                            alt="signin"
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid container sx={{ marginTop: "10px", backgroundColor: "white", borderRadius: "5px" }}>
                                <Grid item xs={12} sx={{ height: 'auto', backgroundColor: 'white', }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
                                        <Tabs
                                            value={value}
                                            onChange={handleTabChange}
                                            aria-label="Event Tabs"
                                            variant="scrollable"
                                            scrollButtons="auto"

                                            sx={{
                                                minHeight: 'unset',
                                                '& .MuiTab-root': {
                                                    minHeight: 'unset',
                                                    padding: '12px 12px',
                                                },
                                                '& .MuiTab-iconWrapper': {
                                                    marginRight: '4px',
                                                },
                                            }}
                                        >
                                            <Tab
                                                icon={<CalendarTodayIcon className="w-4 h-4" />}
                                                iconPosition="start"
                                                label={`Today (${today})`}
                                            />
                                            <Tab
                                                icon={<EventIcon className="w-4 h-4" />}
                                                iconPosition="start"
                                                label={`Upcoming Events (${upcoming})`}
                                            />
                                        </Tabs>

                                        <FormControl sx={{ width: 200 }} size='small'>
                                            <Select
                                                value={radioValue}
                                                onChange={(e) => handleDropdownChange(e.target.value)}
                                                size='small'
                                            >
                                                <MenuItem value="all">All</MenuItem>
                                                <MenuItem value="birthday">Birthday</MenuItem>
                                                <MenuItem value="anniversary">Anniversary</MenuItem>
                                                <MenuItem value="newJoinee">New Joiners</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>

                            </Grid>

                            <Grid item xs={12} sx={{ marginTop: '0px' }}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead sx={{ backgroundColor: "#ECEDFF" }}>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>S/No</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Name</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>User ID</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Date</TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Event</TableCell>
                                            </TableRow>
                                        </TableHead>


                                        <TableBody>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                {row.control === 2 ? (
                                                                    <PeopleAltIcon color="black" />
                                                                ) : (
                                                                    <SchoolIcon color="black" />
                                                                )}
                                                                <Typography variant="body1">{row.name}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>{row.userId}</TableCell>
                                                        <TableCell>
                                                            {formatMonthDate(row.dob || row.doj, !!row.dob)}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                sx={{
                                                                    backgroundColor: row.type === "Birthday" ? "#D4BBFC" : row.type === "Anniversary" ? "#90E0EF" : row.type === "New joinee" ? "#FFFFA3" : "",
                                                                    color: row.type === "Birthday" ? "#421869" : row.type === "Anniversary" ? "#03045E" : row.type === "New joinee" ? "#FF8000" : "",
                                                                    border: row.type === "Birthday" ? "1px solid #9667E0" : row.type === "Anniversary" ? "1px solid #0077B6" : row.type === "New joinee" ? "1px solid #FF9900" : "",
                                                                    display: "inline-block",
                                                                    padding: "4px 10px",
                                                                    borderRadius: "4px",
                                                                    width: "100px",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                {row.type}
                                                            </Typography>

                                                        </TableCell>


                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={value !== 0 ? 6 : 4} align="center">
                                                        No Data Available
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid >
            </Box >
        </>
    );
};